import { progressModel } from '@rosetta/gaia-progress';
import { activityTypes } from '../step/step-constants';

function getActivityIndex(activities, activityId) {
  return activities.findIndex(function (activity) {
    return activity.activityId === activityId;
  });
}

function getStepIndex(activities, activityIndex, stepId) {
  return activities[activityIndex].steps.findIndex(function (s) {
    return s.activityStepId === stepId;
  });
}

var getActivityPagination = function getActivityPagination(sequence, activityIndex, stepIndex) {
  var activities = sequence.activities;

  var activity = activities[activityIndex];
  var previousActivity = activityIndex - 1 >= 0 ? activityIndex - 1 : null;
  var previousStep = stepIndex - 1 >= 0 ? stepIndex - 1 : null;
  var nextActivity = activityIndex + 1 < activities.length ? activityIndex + 1 : null;
  var nextStep = stepIndex + 1 < activity.steps.length ? stepIndex + 1 : null;
  return {
    nextActivity: nextActivity,
    nextStep: nextStep,
    previousActivity: previousActivity,
    previousStep: previousStep
  };
};

var getIsReferenceSequence = function getIsReferenceSequence(sequence) {
  return sequence && sequence.interaction === 'reference';
};

var getIsTestSequence = function getIsTestSequence(sequence) {
  return sequence && sequence.interaction === 'test';
};

var getActivityByIndex = function getActivityByIndex(sequence, activityIndex) {
  var activities = sequence.activities;

  return activities[activityIndex];
};

/** Validates path on SequencePage
 *
 * @param activitySlug {string | number}
 *      - can be 'objectives', 'summary', activityId or activityIndex + 1
 * @param stepSlug {string | number}
 *      - can be stepId or stepIndex + 1
 * @param activities {array}
 *      - list of sequence activities
 *
 * @return {boolean}
 */
function validatePath(activitySlug, stepSlug, activities) {
  if (!stepSlug) {
    return activitySlug === activityTypes.OBJECTIVES || activitySlug === activityTypes.SUMMARY;
  }

  var activity = null;
  if (isNaN(activitySlug)) {
    // not a number so it is an id or it is garbage
    activity = activities.find(function (a) {
      return a.activityId === activitySlug;
    });
  } else {
    activity = activities[activitySlug - 1];
  }
  if (!activity) {
    return false;
  }
  var step = null;
  if (isNaN(stepSlug)) {
    // not a number so it is an id or it is garbage
    step = activity.steps.find(function (s) {
      return s.activityStepId === stepSlug;
    });
  } else {
    step = activity.steps[stepSlug - 1];
  }
  return !!step;
}

/** Get sequence path depending on progress
 *
 * @param currentUrl {string}
 *      - url from React Router match
 * @param currentParams {{ [slug]: {string} }}
 *      - object containing slugs (from React Router match params)
 * @param activities {array}
 *      - list of sequence activities
 * @param sequenceProgress
 *
 * @return {string} full path
 */
function pathFromProgress(currentUrl, currentParams, activities, sequenceProgress) {
  var activitySlug = currentParams.activitySlug,
      stepSlug = currentParams.stepSlug;

  if (stepSlug || activitySlug === activityTypes.OBJECTIVES || activitySlug === activityTypes.SUMMARY) {
    // everything set (either has step slug or don't need it)
    return currentUrl;
  }
  if (activitySlug) {
    // open first step by default
    return currentUrl + '/1';
  }
  var newActivitySlug = activityTypes.SUMMARY;
  if (!sequenceProgress) {
    // sequence is not even started yet, display objectives
    newActivitySlug = activityTypes.OBJECTIVES;
  } else {
    // find first activity that isn't completed
    for (var i = 0; i < activities.length; i++) {
      var activityProgress = progressModel.getActivityProgress(sequenceProgress, activities[i].activityId);
      var isCompleted = progressModel.activityIsCorrect(activityProgress);
      if (!isCompleted) {
        newActivitySlug = i + 1 + '/1';
        break;
      }
    }
  }
  return currentUrl + '/' + newActivitySlug;
}

export var sequenceModel = {
  getActivityIndex: getActivityIndex,
  getStepIndex: getStepIndex,
  getActivityPagination: getActivityPagination,
  getIsReferenceSequence: getIsReferenceSequence,
  getIsTestSequence: getIsTestSequence,
  getActivityByIndex: getActivityByIndex,
  validatePath: validatePath,
  pathFromProgress: pathFromProgress
};